import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useExchangeFetchOther, useHardCode } from "../../hooks";
import { FullPageLoader } from "..";
import { ItemCard } from "../";
import {
  removeInsignificantZero,
  spaceAfterComma,
  htmlColorPicker,
  capitalizeFirstLetter,
} from "../../Utilities";
// import "./exchangeOthers.css";

export const ExchangeOthers = () => {
  const {
    colors,
    setColorID,
    setSelectedColor,
    colorID,
    sizes,
    setSizeID,
    setSelectedSize,
    sizeID,
    productMainView,
    others,
    otherLabel,
    noVariantAvailable,
    setSelectedOthers,
    otherID,
    setOtherID,
    isExLoader,
    disableContinueButton,
    isActiveSquare,
  } = useExchangeFetchOther();
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const navigate = useNavigate();
  const productDetailsState = useSelector((state) => state.productDetails);
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const [activeSquare, setActiveSquare] = useState(0);

  const old_item_name = exchangeSettingsState?.selectedProductName;
  const old_item_value =
    productDetailsState?.currency +
    removeInsignificantZero(parseFloat(exchangeSettingsState?.availableCredit));
  const old_item_variants = spaceAfterComma(
    exchangeSettingsState.itemToBeReturned?.substring(
      0,
      exchangeSettingsState.itemToBeReturned?.length - 1
    )
  ).replace(/,/g, "/");

  const new_item_name = exchangeSettingsState?.newItemName;
  const new_item_value =
    productDetailsState?.currency +
    removeInsignificantZero(parseFloat(exchangeSettingsState?.newItemPrice));
  const new_item_color =
    exchangeSettingsState?.variantLabels?.[0] +
    (exchangeSettingsState?.newItemVariations?.tags.length > 0
      ? exchangeSettingsState?.newItemVariations?.tags?.[0]
      : "");
  const new_item_size =
    exchangeSettingsState?.variantLabels?.[1] +
    exchangeSettingsState?.newItemVariations?.tags?.[1];
  const new_item_other =
    exchangeSettingsState?.variantLabels?.[2] +
    exchangeSettingsState?.newItemVariations?.tags?.[2];
  let new_item_variants =
    (new_item_color ? new_item_color + "/ " : "") +
    (new_item_size ? new_item_size + "/ " : "") +
    (new_item_other ? new_item_other : "");
  new_item_variants = new_item_variants
    ?.replace(/\s+$/, "")
    ?.replace(/\/$/, "");
  const buttonHandler = () => {
    return !exchangeSettingsState.isImageUpload
      ? navigate("/ExchangePayment")
      : navigate("/photo");
  };

  const backHandler = () => {
    window.history.back();
  };

  const activeSquareOption = (index) => {
    setActiveSquare(index);
  };

  return (
    <>
      {isExLoader ? (
        <FullPageLoader />
      ) : (
        <main className="option choose">
          <div className="saara__container ">
            <div className="option__row option__row_others">
              <div className="option__wrapper">
                <div className="row__title mobile_hide">
                  <Link
                    to=""
                    onClick={backHandler}
                    className="btn__small_screen"
                  >
                    <img src="assets/svg/chevron_left.svg" alt="back" />
                  </Link>
                  <h1 className="option__title saara-title">
                    {
                      storeConfigState?.themeConfig
                        ?.exchange_product_detail_left_title
                    }
                  </h1>
                </div>
                <div className="option__panel">
                  <div className="option__subtitle__main">
                    {/* <h2 className="option__subtitle">
                      {noVariantAvailable === true
                        ? ""
                        : "Exchange for Other variants"}
                    </h2> */}
                    <h2 className="option__subtitle">
                      {exchangeSettingsState?.selectedProductNameOther}
                    </h2>
                  </div>
                  <div className="variant_options">
                    <div
                      className={`option__colors variant_options_content ${
                        exchangeSettingsState?.selectedOtherVariationObject
                          ?.options[0]?.values?.length > 0 || "saara-d-none"
                      }`}
                    >
                      <span className="option__name">
                        {" "}
                        {
                          exchangeSettingsState?.selectedOtherVariationObject
                            ?.options[0]?.name
                        }
                      </span>
                      <div className="option__choise square_box_main">
                        {colors?.map((item, index) => {
                          return (
                            <span
                              key={index}
                              onClick={() => {
                                setColorID(index);
                                setSelectedColor(item);
                              }}
                              class="square-box-space"
                            >
                              {isActiveSquare ? (
                                <div
                                  class={`square-option ${
                                    activeSquare === index
                                      ? "square-active-option"
                                      : ""
                                  }`}
                                  onClick={() => activeSquareOption(index)}
                                >
                                  <div class="square-content">
                                    {htmlColorPicker(item).toUpperCase()}
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <input
                                    type="radio"
                                    name="color"
                                    className="option__choise_radio"
                                    id={`color-${index}`}
                                    checked={index === colorID}
                                  />
                                  <label
                                    htmlFor={`color-${index}`}
                                    className="option__choise_label label__color"
                                    title={item}
                                  >
                                    <span
                                      className="option__choise_circle"
                                      data-color="#D94036"
                                      style={{
                                        background: htmlColorPicker(item),
                                      }}
                                    >
                                      <span
                                        className="option__choise_ring"
                                        style={{
                                          border: `2px solid ${htmlColorPicker(
                                            item
                                          )}`,
                                        }}
                                      ></span>
                                    </span>
                                  </label>
                                </div>
                              )}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    <div
                      className={`option__size variant_options_content ${
                        exchangeSettingsState?.selectedOtherVariationObject
                          ?.options[1]?.values?.length > 0 || "saara-d-none"
                      }`}
                    >
                      <span className="option__name">
                        {" "}
                        {
                          exchangeSettingsState?.selectedOtherVariationObject
                            ?.options[1]?.name
                        }
                      </span>
                      <div className="option__choise">
                        {sizes?.map((item, index) => {
                          return (
                            <span
                              onClick={() => {
                                setSizeID(index);
                                setSelectedSize(item);
                              }}
                              key={index}
                            >
                              <input
                                type="radio"
                                name="size"
                                className="option__choise_radio"
                                id={`size-${index}`}
                                checked={index === sizeID}
                              />
                              <label
                                htmlFor={`size-${index}`}
                                className="option__choise_label
                                        label__size"
                              >
                                <span className="option__choise_square">
                                  {item}
                                </span>
                              </label>
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    <div
                      className={`option__size variant_options_content ${
                        exchangeSettingsState?.selectedOtherVariationObject
                          ?.options[2]?.values?.length > 0 || "saara-d-none"
                      }`}
                    >
                      {
                        <span className="option__name">
                          {" "}
                          {
                            exchangeSettingsState?.selectedOtherVariationObject
                              ?.options[2]?.name
                          }
                        </span>
                      }
                      <div className="option__choise">
                        {others?.map((item, index) => {
                          return (
                            <span
                              onClick={() => {
                                setOtherID(index);
                                setSelectedOthers(item);
                              }}
                              key={index}
                            >
                              <input
                                type="radio"
                                name="other"
                                className="option__choise_radio"
                                id={`other-${index}`}
                                checked={index === otherID}
                              />
                              <label
                                htmlFor={`other-${index}`}
                                className="option__choise_label
                                        label__size"
                              >
                                <span className="option__choise_square">
                                  {item}
                                </span>
                              </label>
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" saara-d-flex-exchange-others btn-main-big exchange-btn-main show-mobile ">
                  <button
                    className="saara_custom_btn saara__btn btn__back back_page btn__big_screen margin-right-20 btn-back-big-device"
                    onClick={backHandler}
                  >
                    {storeConfigState?.themeConfig?.back_button_label}
                  </button>
                  <button
                    className={`saara_custom_btn form__btn btn-continue-big-device btn-continue-others   ${
                      disableContinueButton && "form__btn__disabled"
                    }`}
                    onClick={buttonHandler}
                    disabled={disableContinueButton}
                  >
                    {storeConfigState?.themeConfig?.continue_button_label}
                  </button>
                </div>
              </div>
              <div className="item_card_main">
                <ItemCard
                  label={
                    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                      ? PURE_FEMALE_TRANSLATION.exchange_text.old
                      : storeConfigState?.themeConfig
                          ?.exchange_review_old_product_tag_label
                  }
                  imageSrc={selectedProductDetailsState.selectedProductImage}
                  value={`${
                    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                      ? PURE_FEMALE_TRANSLATION.exchange_text.exchange_value
                      : storeConfigState?.themeConfig
                          ?.exchange_product_detail_right_card_title
                  }: ${old_item_value}`}
                  name={old_item_name}
                  variants={old_item_variants}
                  labelClass="old_item_label"
                />
                <ItemCard
                  label={
                    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                      ? PURE_FEMALE_TRANSLATION.exchange_text.new
                      : storeConfigState?.themeConfig
                          ?.exchange_review_new_product_tag_label
                  }
                  imageSrc={exchangeSettingsState?.newItemVariations?.img_url}
                  value={`${
                    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                      ? PURE_FEMALE_TRANSLATION.exchange_text.exchange_value
                      : storeConfigState?.themeConfig
                          ?.exchange_review_item_value_label
                  }: ${new_item_value} `}
                  name={new_item_name}
                  variants={new_item_variants?.replace(/\/$/, "")}
                  labelClass="new_item_label"
                />
                {disableContinueButton && (
                  <span className="info__error error-items exchange-out-of-stock">
                    {storeConfigState?.themeConfig?.errors_product_out_of_stock}
                  </span>
                )}
              </div>
              <div className="saara-d-flex-exchange-others btn-main-big exchange-btn-main">
                <button
                  className="saara_custom_btn saara__btn btn__back back_page btn__big_screen hide-mobile margin-right-20 btn-back-big-device"
                  onClick={backHandler}
                >
                  {storeConfigState?.themeConfig?.back_button_label}
                </button>
                <button
                  className={`saara_custom_btn form__btn btn-continue-big-device hide-mobile  ${
                    disableContinueButton && "form__btn__disabled"
                  }`}
                  onClick={buttonHandler}
                  disabled={disableContinueButton}
                >
                  {storeConfigState?.themeConfig?.continue_button_label}
                </button>
              </div>
              <div className="row__title mobile_show">
                <Link to="" onClick={backHandler} className="btn__small_screen">
                  <img src="assets/svg/chevron_left.svg" alt="back" />
                </Link>
                <h1 className="option__title saara-title">
                  {
                    storeConfigState?.themeConfig
                      ?.exchange_product_detail_left_title
                  }{" "}
                </h1>
              </div>
            </div>
          </div>
        </main>
      )}
    </>
  );
};
